import codifyUrlStateParam from './codifyURLStateParams';

export default (state, userId) => {
  const decodedState = codifyUrlStateParam.decode(state);
  return `/#/dashboard/${decodedState.ledgerType}/${decodedState.ledgerRegion}/${decodedState.formType}/${decodedState.ledgerId}?userId=${userId}`;
}



// WEBPACK FOOTER //
// ./src/app/helpers/createSmeRedirectUrl.js